const listeners = new Set();

export const subscribeSchedulerPointerDrag = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const emitSchedulerPointerDrag = (payload) => {
  listeners.forEach((listener) => {
    try {
      listener(payload);
    } catch (_) {
      /* ignore listener errors */
    }
  });
};
